import React from "react";
import SVGraphics from "../../../assets/SVGraphics";
import { useViewer } from "./context/ViewerContext";
import { SlideInput } from "../../../components/input/SlideInput";

const TOOL_ICONS = [
  "MouseIcon",
  "HandIcon",
  "TriangleMeasurementIcon",
  "MeasurementIcon",
];

//  "ProbeOnly",

const Header = ({ dicomData, patientId, onSplitClick,goBackToMenu }) => {
  const {
    activeTool,
    setActiveTool,
    lastPrimaryTool,
    zoom,
    setZoom,
    notesOpen,
    splitState,
    setNotesOpen,
    graphOpen,
    setGraphOpen,
    setSplitState,
    scrollLinked,
    setScrollLinked,
  } = useViewer();

  const handleSelectIcon = (iconName) => {
    setActiveTool((prev) => (prev === iconName ? null : iconName));
  };

  const [toggleValue, setToggleValue] = React.useState(1);

  const handleToggleChange = (name, value) => {
    setToggleValue(value);
    // Don't change activeTool - just trigger overlay update
    // The overlay state will be handled in DICOMViewer
    setActiveTool(value === 1 ? "AllColors" : "ProbeOnly");
  };

  // Determine which tool icon should be highlighted
  // If activeTool is an overlay/filter state, use lastPrimaryTool
  const getEffectiveTool = () => {
    if (activeTool === "AllColors" || activeTool === "ProbeOnly" || activeTool === "MeasurementIcon" || activeTool === null) {
      return lastPrimaryTool;
    }
    return activeTool;
  };

  const effectiveTool = getEffectiveTool();

  return (
    <div className="w-full h-[63px] box-border bg-[black] p-4 flex items-center relative">
      {/* Left: Tools */}
      <div className="flex gap-3">
        {/* BackButton */}       
        <div title="Back">
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={
              activeTool ===" BackButton" ? "BackButton" : "BackButton"
            }
            onClick={() => goBackToMenu()}
          />
        </div>

        {/* Separator */}
        <div className="w-[1px] h-7 bg-[#484848] mx-2" />

        {/* Mouse */}
        <div title="Mouse">
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={
              effectiveTool === "MouseIcon" ? "MouseIconSelected" : "MouseIcon"
            }
            onClick={() => setActiveTool("MouseIcon")}
          />
        </div>

        {/* Hand */}
        <div title="Pan">
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={effectiveTool === "HandIcon" ? "HandIconSelected" : "HandIcon"}
            onClick={() => setActiveTool("HandIcon")}
          />
        </div>

        {/* Triangle Measurement */}
        <div title="Measure length">
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={
              effectiveTool === "TriangleMeasurementIcon"
                ? "TriangleMeasurementIconSelected"
                : "TriangleMeasurementIcon"
            }
            onClick={() => setActiveTool("TriangleMeasurementIcon")}
          />
        </div>
        {/* Grid = independent layout toggle (NOT part of TOOL_ICONS) */}
        <div title={splitState !== "off" ? "Exit Split View" : "Split View"}>
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={splitState !== "off" ? "GridIconSelected" : "GridIcon"}
            onClick={() => {
              if (splitState === "off") {
                onSplitClick && onSplitClick(); // parent runs preflight + loading
              } else {
                setSplitState("off"); // exit split
              }
            }}
          />
        </div>

        {/* Measurement (filter/tool) */}
        <div title="Filter nodules by size">
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={
              activeTool === "MeasurementIcon"
                ? "MeasurementIconSelected"
                : "MeasurementIcon"
            }
            onClick={() => setActiveTool("MeasurementIcon")}
          />
        </div>

        {/* Zoom select */}
        <select
          id="zoomSelect"
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          className="w-17 h-8 px-2 py-1 bg-[#333] rounded-lg text-xs text-white cursor-pointer">
          {[1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3].map((val) => (
            <option key={val} value={val}>{`${val * 100}%`}</option>
          ))}
        </select>

        <div className="flex items-center">
          <SlideInput
            name="headerToggle"
            value={toggleValue}
            onChange={handleToggleChange}
            step={1}
            rightLabel="Show All Colors"
            marginTop="mt-0"
            min={0}
            max={1}
            large={true}
          />
        </div>
      </div>

      {/* Center: Patient Info */}
      <div className="absolute left-1/2 transform -translate-x-1/2">
        <label className="text-white text-sm">
          {`Patient ID ${patientId} / Case ${dicomData?.caseId || "N/A"}`}
        </label>
      </div>

      <div className="ml-auto flex items-center gap-2">
        {splitState === "on" ? (
          <>
            <div title={scrollLinked ? "Unlink scroll" : "Link scroll"}>
              <SVGraphics
                className="w-7 h-7 cursor-pointer pointer-events-auto"
                svgname={scrollLinked ? "LinkIconSelected" : "LinkIcon"}
                onClick={() => setScrollLinked(!scrollLinked)}
              />
            </div>
            <div title={graphOpen ? "Hide graph" : "Show graph"}>
              <SVGraphics
                className="w-7 h-7 cursor-pointer pointer-events-auto"
                svgname={graphOpen ? "SplitNotesIconSelected" : "SplitNotesIcon"}
                onClick={() => setGraphOpen(!graphOpen)}
              />
            </div>
          </>
        ) : splitState === "loading" ? null : (
          <div title={notesOpen ? "Hide notes" : "Show notes"}>
            <SVGraphics
              className="w-7 h-7 cursor-pointer"
              svgname={notesOpen ? "NotesIconSelected" : "NotesIcon"}
              onClick={() => setNotesOpen(!notesOpen)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
